export default __webpack_public_path__ + "static/media/Group 200.a94f5194.png";